import setup from "@/assets/course-setup.jpg";
import foundations from "@/assets/course-foundations.jpg";
import figure7 from "@/assets/course-7figure.jpg";
import email from "@/assets/course-email.jpg";
import paidTraffic from "@/assets/course-paidtraffic.jpg";
import webinar from "@/assets/course-webinar.jpg";
import defaultCover from "@/assets/course-default.jpg";

const RULES: { match: RegExp; src: string }[] = [
  { match: /setup|getting started|onboarding/i, src: setup },
  { match: /foundation|fundament|basics|essentials/i, src: foundations },
  { match: /7[- ]?figure|six[- ]?figure|million|empire|scale/i, src: figure7 },
  { match: /email|newsletter|list|sequence/i, src: email },
  { match: /paid traffic|ads|meta|youtube|facebook|google ads|ppc/i, src: paidTraffic },
  { match: /webinar|live|broadcast|stream|podcast/i, src: webinar },
];

export function getCourseCover(title: string | null | undefined, override?: string | null): string {
  if (override) return override;
  const t = (title ?? "").trim();
  for (const r of RULES) if (r.match.test(t)) return r.src;
  return defaultCover;
}
